import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import Debounce from '../../js/lib/debounce';

const capMosaic = document.getElementById('CapMosaic');

if(capMosaic)
{
	const initPage = document.getElementById('CapMosaic');

	const initUrl = envVar({
		backendPath: '/CapMosaicPage/GetFiles',
		staticPath: 'js/data/searchInit.json'
	});
	
	var AccordianView = {
		template: '#accordian-view-template',
		props: {
			data: {
				type: Array,	
			},
		},
		data() {
			return {
				loading: true,
			};
		},
		mounted: function() {
			const self = this;
		},
		methods: {
			toggleNode: function(event) {
				const self = this;
				if (event.type === 'keypress' && event.keyCode === 13) {
					self.accordionToggle(event.currentTarget.parentElement);
				}
				// Or Click
				else if (event.type === 'click') {
					self.accordionToggle(event.currentTarget.parentElement);
				}
			},
			// had to recreate this from /components/accordion.js; not ideal..
			// make a library someday..
			openTab: function(element) {
				const self = this;

				// if (!detectMobile() && element.closest('.js-accordion-mobile')) return;
				element.setAttribute('data-open', true);
				// Make button tabable
				if (element.querySelector('.button')){
					element.querySelector('.button').removeAttribute('tabindex');
				}
				// Accessibility
				element.removeAttribute('aria-hidden');
				element.setAttribute('aria-selected', true);
				
			},
			closeTab: function(element) {
				const self = this;

				element.removeAttribute('data-open');
				// Make button tabable
				if (element.querySelector('.button')) {
					element.querySelector('.button').setAttribute('tabindex', '-1');
				}
				// Accessibility
				element.removeAttribute('aria-selected');
				element.setAttribute('aria-hidden', true);
			},
			accordionToggle: function(thisTab) {
				const self = this;
				if (thisTab.getAttribute('data-open')) {
					self.closeTab(thisTab);
				}
				else {
					self.openTab(thisTab);
				}
				
			},
		}
	};

	const capVue = new Vue({
		el: '#CapMosaic',
		components: { 'accordion-view-component': AccordianView, },
		data: {
			currentTab: 'welcome',
			currentReports: [],
			allReports: [],
			currentQuestionnaires: [],
			allQuestionnaires: [],
			input: '',
			loading: true,
		},
		watch: {
			// whenever input changes, this function will run
			input: function(newInput) {
				this.getPrompt();
			}
		},
		mounted: function() {
			const self = this;

			var controltype = initPage.getAttribute('data-pagetype');

			request().get(initUrl + '?type=Reports' + '&control=' + controltype).then(function(response) {
				self.currentReports = response;
				self.allReports = response;

				request().get(initUrl + '?type=Questionnaires' + '&control=' + controltype).then(function(response) {
					self.currentQuestionnaires = response;
					self.allQuestionnaires = response;
					self.loading = false;
				});
			});

		},
		// Methods
		methods: {
			checkSelected: function(item) {
				const self = this;
				
				if(item == self.currentTab)
					return true;
				else
					return false;
			},
			loadCap: function(tab) {
				const self = this;
				self.currentTab = tab;
			},
			getPrompt: Debounce(function() {
				var self = this;

				if (self.input.length < 2) 	
				{
					self.currentReports = self.allReports;
					self.currentQuestionnaires = self.allQuestionnaires;
				}
				else
				{
					self.currentReports = [];
					self.currentQuestionnaires = [];

					var findMatch = new RegExp(self.input,'gi');
					for (var x = 0; x < self.allReports.length; x++) 
					{
						if(self.allReports[x].title.match(findMatch))
							self.currentReports.push(self.allReports[x]);
					}

					for (var y = 0; y < self.allQuestionnaires.length; y++) 
					{
						if(self.allQuestionnaires[y].title.match(findMatch))
							self.currentQuestionnaires.push(self.allQuestionnaires[y]);
					}
				}
			}, 500),

		}
	});
}



// WEBPACK FOOTER //
// ../components/cap/cap.js